import { Card, CardContent, Skeleton } from '@/ui';

const PlanDetailsLoading = () => (
  <Card>
    <CardContent>
      <Skeleton className="mb-2" width="32%" />
      <div className="flex items-center">
        <Skeleton
          className="shrink-0"
          height={48}
          variant="circular"
          width={48}
        />
        <div className="ml-5 w-full">
          <Skeleton width="19%" />
          <Skeleton width="33%" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export default PlanDetailsLoading;
